/**
 * Transforms a flat array of objects into a nested tree structure for React Checkbox Tree.
 * @param {Array} data - The flat array of menu items.
 * @returns {Array} - The transformed tree structure.
 */
export const transformToCheckboxTreeFormat = (data) => {
    // Create a new map and result array to avoid mutating original data
    const map = new Map();
    const result = [];

    // First pass: Create copies of items and initialize children as empty arrays
    const copiedData = data.map(item => {
        const newItem = { ...item, children: [] }; // Copy item and initialize 'children'
        map.set(newItem.id, newItem); // Store the new item in the map
        return newItem;
    });

    // Second pass: Build the hierarchy based on parent-child relationships
    copiedData.forEach(item => {
        if (item.parentId !== -1) {
            const parent = map.get(item.parentId);
            if (parent) {
                parent.children.push({ label: item.label, value: item.id, children: item.children }); // Add item to parent's children array
            }
        } else {
            result.push({ label: item.label, value: item.id, children: item.children }); // Root item
        }
    });

    return result;
};
